import store from "../../index";
import { getTenant } from "../../../services/tenant.js";
import { middleware } from "../../../services/http.js";
let Expiretimer;
let StatusTimer;

// Session concerns on the shared client live here: the 401 auto-logout
// interceptor below, and the default auth headers set on login/autoLogin.
middleware.interceptors.response.use(
  (response) => {
    // console.log("My response axios:", response);
    let requestHeader = response.config.headers.request;

    if (response.data.errorcode === 401 && requestHeader !== "logout") {
      store.dispatch("logout", true);
    }
    return response;
  },
  (err) => {
    console.log("My middleware err", err);
    if (!err.response) {
      return Promise.reject(err);
    }
    let statusCode = err.response.status;
    if (statusCode === 401) {
      store.dispatch("logout");
      return;
    }
    //  else if (statusCode == 404) {
    //   // console.log("my error response", err.response); // this doesnt even console log
    //   err.response.data = { message: err.response.data };
    //   return err.response;
    // }
    return Promise.reject(err);
  }
);
export default {
  middleware,
  async login(context, payload) {
    const response = await middleware.post(
      "/Login",
      JSON.stringify({
        username: payload.username,
        pass: payload.pass,
        isAtuhEmail: payload.isAtuhEmail,
        domain: payload.domain,
        request: payload.request,
      }),
      {
        headers: { request: payload.request },
      }
    );
    const responseData = response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return { success: responseData.success, message: responseData.message };
    }
    // console.log(responseData);
    if (responseData.success) {
      const result = responseData.result;
      localStorage.setItem("token", result.sessionid);
      localStorage.setItem("uname", result.username);
      localStorage.setItem("domain", result.domain);
      let session = +result.sessionLive;
      if (session == 0) {
        session = 2592000;
      }
      const expireTime = session * 1000;
      const expirationDate = new Date().getTime() + expireTime;
      localStorage.setItem("expiration", expirationDate);
      // Timer setup cancelled - session expiration timer removed
      // Expiretimer = setTimeout(function () {
      //   context.dispatch("logout");
      // }, expireTime);
      const payload = {
        token: result.sessionid,
        uname: result.username,
        sessionLive: result.sessionLive,
        permissions: result.permissions,
        fullname: result.fullname,
        exten: result.exten,
        secret: result.secret,
        pbxServer: result.pbxServer,
        pbxPort: result.pbxPort,
        stunURI: result.stunURI,
        turnUser: result.turnUser,
        turnPass: result.turnPass,
        workPlace: result.workPlace,
        workPhone: result.workPhone,
        plugings: result.plugins,
        usePhone: result.isPhone,
        skills: result.skills,
        domain: result.domain,
        type: result.type,
        status: result.status,
        avatar: result.avatar,
        isAutoAnswer: result.isAutoAnswer,
      };
      context.commit("setProfileInfo", payload);
      middleware.defaults.headers.common["token"] = result.sessionid;
      middleware.defaults.headers.common["domain"] = result.domain;
      middleware.defaults.headers.common["uname"] = result.username;
    }
    return { success: responseData.success, message: responseData.message };
  },
  async autoLogin(context) {
    var domain = context.getters.domain;
    if (domain) {
      return { success: true, message: "already logged in" };
    }
    domain = getTenant();
    const response = await middleware.get("/GetSession", {
      headers: {
        domain: domain,
        token: context.getters.token,
        uname: context.getters.uname,
        request: "getSessionInfo",
      },
    });
    const responseData = await response.data;
    if (response.status !== 200) {
      // console.log("login not ok", response);
      return { success: responseData.success, message: responseData.message };
      // const error = new Error(
      //   responseData.message || "Failed to auto login. please reload."
      // );
      // throw error;
    }
    if (responseData.success) {
      const result = responseData.result;
      const payload = {
        token: result.sessionid,
        uname: result.username,
        sessionLive: result.sessionLive,
        permissions: result.permissions,
        fullname: result.fullname,
        exten: result.exten,
        secret: result.secret,
        pbxServer: result.pbxServer,
        pbxPort: result.pbxPort,
        stunURI: result.stunURI,
        turnUser: result.turnUser,
        turnPass: result.turnPass,
        workPlace: result.workPlace,
        workPhone: result.workPhone,
        plugings: result.plugins,
        usePhone: result.isPhone,
        skills: result.skills,
        domain: result.domain,
        type: result.type,
        status: result.status,
        avatar: result.avatar,
        isAutoAnswer: result.isAutoAnswer,
      };
      context.commit("setProfileInfo", payload);
      middleware.defaults.headers.common["token"] = result.sessionid;
      middleware.defaults.headers.common["domain"] = result.domain;
      middleware.defaults.headers.common["uname"] = result.username;
      // Fetch fresh auto-answer status from dedicated endpoint
      context.dispatch("GetAutoAnswerStatus");
    }
    return { success: responseData.success, message: responseData.message };
  },
  localAuthenticate(context) {
    const token = localStorage.getItem("token");
    const uname = localStorage.getItem("uname");
    const lang = localStorage.getItem("lang");
    const expiration = localStorage.getItem("expiration");
    const expireTime = +expiration - new Date().getTime();
    if (!token || !uname) {
      return null;
    }
    if (expireTime < 0) {
      return null;
    }
    if (lang) {
      context.commit("setLang", lang);
    }
    // Timer setup cancelled - session expiration timer removed
    // Expiretimer = setTimeout(function () {
    //   context.dispatch("logout");
    // }, expireTime);
    if (localStorage.getItem("status")) {
      const statusStrored = localStorage.getItem("status");
      const statusDate = +statusStrored - new Date().getTime();
      context.commit("setRestEndtime", statusStrored);
      StatusTimer = setTimeout(function () {
        context.dispatch("setUserStatus", {
          username: context.getters.uname,
          domain: context.getters.domain,
          statusUser: context.getters.uname,
          status: 1,
          period: "",
          request: "set status",
          skills: context.getters.skills ? context.getters.skills : [],
        });
      }, statusDate);
    }
    context.commit("setProfileInfo", {
      token: token,
      uname: uname,
    });
    return true;
  },

  async logout(context, auto) {
    const payload = {
      token: null,
      uname: null,
      sessionLive: null,
      permissions: null,
      fullname: null,
      exten: null,
      secret: null,
      workPlace: null,
      workPhone: null,
      plugings: null,
      usePhone: null,
      skills: null,
      domain: null,
      type: null,
      avatar: null,
    };
    const domain = context.getters.domain;
    const uname = context.getters.uname;
    if (!domain || !uname) {
      context.commit("setProfileInfo", payload);
      return;
    }
    var skills = context.getters.skills;
    if (!skills) {
      skills = [];
    }
    context.commit("setSessionLogOff", true);

    // Cleanup WebRTC service before logout
    try {
      const WebRTCService = (await import("@/services/WebRTCService.js"))
        .default;
      if (WebRTCService) {
        console.log("Cleaning up WebRTC service during logout...");
        WebRTCService.cleanup();
      }
    } catch (error) {
      console.warn("Failed to cleanup WebRTC service:", error);
    }
    const response = await middleware.post(
      "/Logout",
      JSON.stringify({
        skills: skills,
      }),
      {
        headers: { request: "logout" },
      }
    );

    const responseData = response.data;
    // console.log("logout response data: ", responseData);
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }

    if (responseData.success || responseData.errorcode === 401) {
      // console.log("My phone is susccses");
      // const socket = context.getters.phoneSocket;
      // console.log("My socket logout", socket);
      // if (socket) {
      //   socket.disconnect();
      // }
      // const phone = context.getters.agentPhone;
      // console.log("My cool phone logout", phone);
      // if (phone) {
      //   phone.unregister();
      // }
      const dahsboardInt = context.getters.dahsboardInterval;
      if (dahsboardInt) {
        clearInterval(dahsboardInt);
      }
      const lastCallsInt = context.getters.lastCallsInterval;
      if (lastCallsInt) {
        clearInterval(lastCallsInt);
      }
      const summaryInt = context.getters.summaryInterval;
      if (summaryInt) {
        clearInterval(summaryInt);
      }
      const summaryMainInt = context.getters.mainSummaryInterval;
      if (summaryMainInt) {
        clearInterval(summaryMainInt);
      }
      const mainTrafficInt = context.getters.mainTrafficInterval;
      if (mainTrafficInt) {
        clearInterval(mainTrafficInt);
      }
      const adminDashInt = context.getters.adminDashboardInterval;
      if (adminDashInt) {
        clearInterval(adminDashInt);
      }

      if (auto) {
        context.commit("setProgressStatus", { show: false, message: "" });
        context.commit("SetMessageDialog", { show: false, message: "" });
      }
      // console.log(responseData);
      localStorage.removeItem("token");
      localStorage.removeItem("uname");
      localStorage.removeItem("expiration");
      localStorage.removeItem("status");
      localStorage.removeItem("domain");
      clearTimeout(Expiretimer);
      clearTimeout(StatusTimer);
      // console.log("My payload: ", payload);
      context.commit("setProfileInfo", payload);
    } else {
      context.commit("setSessionLogOff", false);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async setUserStatus(context, payload) {
    const request = {
      statusUser: payload.user,
      status: payload.status,
      skills: context.getters.skills ? context.getters.skills : [],
      isAdmin: payload.isAdmin,
    };
    if (payload.reason) {
      request.reason = payload.reason;
    }
    if (payload.period) {
      request.period = payload.period;
    }
    const response = await middleware.post(
      "/SetStatus",
      JSON.stringify(request),
      {
        headers: { request: "setStatus" },
      }
    );
    const responseData = response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      if (response.status === 401) {
        context.dispatch("logout");
        return;
      }
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    // console.log(responseData);
    if (responseData.success) {
      if (payload.status == 2 && payload.period) {
        const statusPeriod = +payload.period * 60 * 1000;

        const statusDate = new Date().getTime() + statusPeriod;
        // console.log(
        //   "My setted value in date",
        //   new Date(statusDate).toISOString()
        // );
        localStorage.setItem("status", statusDate);
        context.commit("setRestEndtime", statusDate);
        StatusTimer = setTimeout(function () {
          let statusPayload = {
            username: context.getters.uname,
            domain: context.getters.domain,
            user: payload.user,
            status: 1,
            period: "",
            request: "set status",
            skills: context.getters.skills ? context.getters.skills : [],
          };
          context.dispatch("setUserStatus", statusPayload);
        }, statusPeriod);
      } else {
        clearTimeout(StatusTimer);
        localStorage.removeItem("status");
        context.commit("setRestEndtime", null);
      }
      // console.log("My payload: ", payload);
      context.commit("setStatus", { status: payload.status });
    }

    return { success: responseData.success, message: responseData.message };
  },

  async setUserSkill(context, payload) {
    const response = await middleware.post(
      "/SetUserSkill",
      JSON.stringify({
        workPlace: payload.workPlace,
        phone: payload.phone,
        skills: JSON.parse(JSON.stringify(payload.skills)),
      }),
      {
        headers: { request: "setUserSkill" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    // console.log(responseData);
    if (responseData.success) {
      context.commit("setSkills", {
        skills: payload.skills,
        workPhone: payload.phone,
        workPlace: payload.workPlace,
      });
    }

    return { success: responseData.success, message: responseData.message };
  },
  async GetProfile(context) {
    const response = await middleware.get("/GetProfileInfo", {
      headers: { request: "getProfileInfo" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
      // const error = new Error(
      //   responseData.message || "Failed to set user skill"
      // );
      // throw error;
    }
    // console.log(responseData);
    if (responseData.success) {
      context.commit("setProfile", { profile: responseData.result });
    }

    return { success: responseData.success, message: responseData.message };
  },
  async GetShortCodes(context) {
    const response = await middleware.get("/GetShortCodes", {
      headers: { request: "GetShortCodes" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
      // const error = new Error(
      //   responseData.message || "Failed to set user skill"
      // );
      // throw error;
    }
    // console.log(responseData);
    if (responseData.success) {
      context.commit("setShortCodes", responseData.result.shortCodes);
    }

    return { success: responseData.success, message: responseData.message };
  },
  async GetUserSMSLog(context) {
    const response = await middleware.get("/GetUserSMSLog", {
      headers: { request: "GetUserSMSLog" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
      // const error = new Error(
      //   responseData.message || "Failed to set user skill"
      // );
      // throw error;
    }
    // console.log(responseData);
    if (responseData.success) {
      context.commit("setSMSLogs", responseData.result.logs);
    }

    return { success: responseData.success, message: responseData.message };
  },

  async EditProfile(context, payload) {
    const body = {
      fullname: payload.fullname,
      phone: payload.phone,
      email: payload.email,
    };
    const response = await middleware.post(
      "/EditProfile",
      JSON.stringify(body),
      {
        headers: { request: "EditProfile" },
      }
    );
    const responseData = await response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    // console.log("My resp data edit profile", responseData);
    if (responseData.success) {
      context.commit("setProfile", { profile: responseData.result });
      context.commit("setFullName", payload.fullname);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async ResetPassword(_, payload) {
    const response = await middleware.post(
      "/ResetMyPassword",
      JSON.stringify({
        oldpassword: payload.oldPassword,
        newpassword: payload.newPassword,
      })
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return { success: responseData.success, message: responseData.message };
  },

  async UploadProfileImg(_, payload) {
    let formData = new FormData();
    formData.append("file", payload.file);
    try {
      const response = await middleware.post("UploadProfileImg", formData, {
        headers: {
          request: "UploadProfileImg",
          "Content-Type": "multipart/form-data",
          filename: payload.filename,
          filesize: payload.filesize,
        },
      });

      if (response.status !== 200) {
        return { success: false, message: response.data.message };
      }

      const responseData = response.data;
      return {
        success: responseData.success,
        message: responseData.message,
        data: responseData,
      };
    } catch (error) {
      console.error("Error during upload:", error);
      return { success: false, message: "Upload failed" };
    }
  },

  async SendSMS(_, payload) {
    const response = await middleware.post(
      "/SendSMSMessage",
      JSON.stringify({
        mdn: payload.number,
        shortCode: payload.shortCode,
        textMessage: payload.message,
      })
    );

    const responseData = response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return { success: responseData.success, message: responseData.message };
  },

  async GetInitCRM(context) {
    const response = await middleware.get("/GetInitCRM", {
      headers: { request: "GetInitCRM" },
    });
    const responseData = await response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    // console.log(responseData);
    if (responseData.success) {
      context.commit("setCRMInitInfo", responseData.result.info);
    }

    return { success: responseData.success, message: responseData.message };
  },

  async GetCallerInfo(_, payload) {
    var params = "callerID=" + payload;
    const response = await middleware.get("/GetCallerInfo?" + params, {
      headers: { request: "GetCallerInfo" },
    });
    const responseData = await response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else if (responseData.errorcode) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else {
      return {
        success: true,
        message: "request done successfully",
        errorcode: 0,
        info: responseData,
      };
    }
  },
  async GetCallerLastTickets(_, payload) {
    const response = await middleware.get("/GetCallerTickets", {
      params: {
        callerID: payload,
      },
      headers: { request: "GetCallerTickets" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else if (responseData.errorcode) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else {
      return {
        success: true,
        message: "request done successfully",
        errorcode: 0,
        lastTickets: responseData.lastTickets,
      };
    }
    // console.log("My last tickets check", responseData);
    // console.log("My last tickets check", responseData.lastTickets);
  },
  async GetUserConversations() {
    const response = await middleware.get("/GetUserConversations", {
      headers: { request: "GetUserConversations" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else if (responseData.errorcode) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else {
      return {
        success: true,
        message: "request done successfully",
        errorcode: 0,
        conversations: responseData.result.conversations,
      };
    }
  },

  async GetChatUsers() {
    const response = await middleware.get("/GetChatUsers", {
      headers: { request: "GetChatUsers" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else if (responseData.errorcode) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else {
      return {
        success: true,
        message: "request done successfully",
        errorcode: 0,
        users: responseData.result.users,
      };
    }
  },

  async GetChatConversationMessages(_, payload) {
    const response = await middleware.get("/GetChatConversationMessages", {
      params: {
        conversation_id: payload.conversation_id,
        offset: payload.offset,
        limit: payload.limit,
      },
      headers: { request: "GetChatConversationMessages" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else if (responseData.errorcode) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else {
      return {
        success: true,
        message: "request done successfully",
        errorcode: 0,
        messages: responseData.result.messages,
        not_read_msgs: responseData.result.not_read_msgs,
      };
    }
  },

  async GetUserActiveOmniConversations() {
    const response = await middleware.get("/GetUserActiveOmniConversations", {
      headers: { request: "GetUserActiveOmniConversations" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else if (responseData.errorcode) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else {
      return {
        success: true,
        message: "request done successfully",
        errorcode: 0,
        conversations: responseData.result.conversations,
      };
    }
  },
  async GetCurrentActiveOmniConversations() {
    const response = await middleware.get(
      "/GetCurrentActiveOmniConversations",
      {
        headers: { request: "GetCurrentActiveOmniConversations" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else if (responseData.errorcode) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else {
      return {
        success: true,
        message: "request done successfully",
        errorcode: 0,
        conversations: responseData.result.conversations,
      };
    }
  },
  async GetOmniChannelUsers() {
    const response = await middleware.get("/GetOmniChannelUsers", {
      headers: { request: "GetOmniChannelUsers" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else if (responseData.errorcode) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else {
      return {
        success: true,
        message: "request done successfully",
        errorcode: 0,
        agents: responseData.result.agents,
      };
    }
  },
  async GetOmniConversationMessages(_, payload) {
    const response = await middleware.get("/GetOmniConversationMessages", {
      params: {
        conversation_id: payload.conversation_id,
        offset: payload.offset,
        limit: payload.limit,
      },
      headers: { request: "GetOmniConversationMessages" },
    });

    const responseData = await response.data;
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else if (responseData.errorcode) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else {
      return {
        success: true,
        message: "request done successfully",
        errorcode: 0,
        messages: responseData.result.messages,
        not_read_msgs: responseData.result.not_read_msgs,
      };
    }
  },

  async CloseOmniConversation(_, payload) {
    const response = await middleware.post(
      "/CloseOmniConversation",
      JSON.stringify(payload),
      {
        headers: { request: "CloseOmniConversation" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async ReassignOmniConversation(_, payload) {
    const response = await middleware.post(
      "/ReassignOmniConversation",
      JSON.stringify(payload),
      {
        headers: { request: "ReassignOmniConversation" },
      }
    );

    const responseData = await response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return { success: responseData.success, message: responseData.message };
  },

  async GetACWSettings(context) {
    const response = await middleware.get("/GetACWSettings", {
      headers: { request: "GetACWSettings" },
    });
    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    if (responseData.success) {
      context.commit("setACWSettings", responseData.result.settings);
    }
    return { success: responseData.success, message: responseData.message };
  },

  async GetLocalCRMFields(context) {
    const response = await middleware.get("/GetLocalCRMFields", {
      headers: { request: "GetLocalCRMFields" },
    });
    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    if (responseData.success) {
      context.commit("setCRMLocalFields", responseData.result.fields);
    }
    return { success: responseData.success, message: responseData.message };
  },
  async GetLocalTicketingFields(context) {
    const response = await middleware.get("/GetLocalTicketingFields", {
      headers: { request: "GetLocalTicketingFields" },
    });
    const responseData = response.data;
    if (response.status !== 200) {
      return { success: responseData.success, message: responseData.message };
    }
    if (responseData.success) {
      context.commit("setTicketingLocalFields", responseData.result.fields);
    }
    return { success: responseData.success, message: responseData.message };
  },

  async SetACWTime(_, payload) {
    const response = await middleware.post(
      "/SetACWTime",
      JSON.stringify({
        ...payload,
      }),
      {
        headers: { request: "SetACWTime" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetCallerInfo(_, payload) {
    const response = await middleware.post(
      "/SetCallerInfo",
      JSON.stringify({
        ...payload,
      }),
      {
        headers: { request: "SetCallerInfo" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SetNewTicket(_, payload) {
    const response = await middleware.post(
      "/SetNewTicket",
      JSON.stringify({
        ...payload,
      }),
      {
        headers: { request: "SetNewTicket" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return { success: responseData.success, message: responseData.message };
  },
  async SendMessageToAssistantBot(_, payload) {
    const response = await middleware.post(
      "/SendMessageToAssistantBot",
      JSON.stringify({
        ...payload,
      }),
      {
        headers: { request: "SendMessageToAssistantBot" },
      }
    );
    if (!response) {
      // console.log(responseData);
      return {
        success: false,
        message: "error sending to API",
      };
    }
    const responseData = response.data;
    if (!response?.status == 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    } else if (!responseData.success) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return {
      success: responseData.success,
      message: responseData.message,
      errorcode: 0,
      reply: responseData.result.reply,
      conversation_id: responseData.result.conversation_id,
    };
  },
  async MakeCallBackRequest(_, payload) {
    const response = await middleware.post(
      "/MakeCallBackRequest",
      JSON.stringify({
        ...payload,
      }),
      {
        headers: { request: "MakeCallBackRequest" },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      // console.log(responseData);
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return { success: responseData.success, message: responseData.message };
  },

  async requestForgotPasswordOTP(_, payload) {
    const response = await middleware.post(
      "/ForgotPasswordRequest",
      JSON.stringify({
        email: payload.email,
      }),
      {
        headers: {
          request: "ForgotPasswordRequest",
          domain: payload.domain,
          Uname: "123",
        },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return { success: responseData.success, message: responseData.message, username: responseData.result.username };
  },

  async verifyForgotPasswordOTP(_, payload) {
    const response = await middleware.post(
      "/ConfirmPasswordResetRequestOTP",
      JSON.stringify({
        otp: payload.otp,
      }),
      {
        headers: {
          request: "ConfirmPasswordResetRequestOTP",
          domain: payload.domain,
          Uname: payload.uname,
        },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return { success: responseData.success, message: responseData.message };
  },

  async resetForgotPassword(_, payload) {
    const response = await middleware.post(
      "/ResetForgottenPassword",
      JSON.stringify({
        otp: payload.otp,
        newpassword: payload.newPassword,
      }),
      {
        headers: {
          request: "ResetForgottenPassword",
          domain: payload.domain,
          Uname: payload.uname,
        },
      }
    );

    const responseData = response.data;
    if (response.status !== 200) {
      return {
        success: responseData.success,
        message: responseData.message,
      };
    }
    return { success: responseData.success, message: responseData.message };
  },
};
